import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const { brand } = useApp();
  const navigate = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Berhasil masuk");
      navigate(loc.state?.from || (u.role === "admin" ? "/admin" : u.role === "seller" ? "/seller" : "/"));
    } catch (e2) { setErr(errMsg(e2)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative bg-rl-secondary">
        <img src="https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" alt="" className="w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 grid place-items-center p-12">
          <div className="text-white max-w-md">
            <div className="font-serif text-4xl font-bold">{brand?.brand_name || "RELOVA"}</div>
            <p className="mt-4 text-xl text-white/90 font-serif italic">"{brand?.tagline || "Barang Bagus Layak Dicintai Lagi."}"</p>
          </div>
        </div>
      </div>
      <div className="grid place-items-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm">
          <Link to="/" className="font-serif text-3xl font-bold text-rl-ink lg:hidden">{brand?.brand_name || "RELOVA"}</Link>
          <h1 className="mt-6 font-serif text-3xl font-bold text-rl-ink">Masuk</h1>
          <p className="text-sm text-rl-muted mt-1">Selamat datang kembali.</p>
          {err && <div className="mt-4 rounded-lg bg-rose-50 border border-rose-200 text-rose-700 text-sm px-3 py-2">{err}</div>}
          <div className="mt-6 space-y-4">
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="Email" className="w-full rounded-xl border border-rl-border bg-white px-4 py-3 text-sm outline-none focus:border-rl-primary" />
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="Kata sandi" className="w-full rounded-xl border border-rl-border bg-white px-4 py-3 text-sm outline-none focus:border-rl-primary" />
          </div>
          <button data-testid="login-submit" disabled={loading} className="mt-6 w-full rounded-full bg-rl-primary hover:bg-rl-primaryHover text-white font-bold py-3 transition-colors disabled:opacity-50">
            {loading ? "Memproses..." : "Masuk"}</button>
          <p className="mt-4 text-sm text-center text-rl-muted">Belum punya akun? <Link to="/register" className="text-rl-primary font-semibold">Daftar</Link></p>
        </form>
      </div>
    </div>
  );
}
